import { GetAllMyOrganizations } from "@/graphql/queries.js";
import { generateClient } from "aws-amplify/api";
const client = generateClient();
export const GetAllMyOrganizationsNew = {
  data() {
    return {
      GetAllMyOrganization: [],
      overlay: false,
      noDataText: "",
    };
  },
  methods: {
    async GetAllMyOrganizationMethod() {
      try {
        this.overlay = true;
        let result = await client.graphql({
          query: GetAllMyOrganizations,
          variables: {
            input: {
              user_email_id:
                this.$store.getters.get_current_user_details.user_email_id,
            },
          },
        });

        this.GetAllMyOrganization = JSON.parse(
          result.data.GetAllMyOrganizations
        ).data.items;
        this.overlay = false;
      } catch (error) {
        this.overlay = false;
        this.GetAllOrganization = [];
      }
    },
  },
};
